<template>
  <div>
    <div v-if="userIsArg">
      <b-link
        v-if="mpLink != null"
        class="to_MP_button"
        target="_blank"
        :href="mpLink"
      >
        {{ $t('lang.mp_payments.mp_button') }}
        <img
          src="../../assets/img/payments/mp-logo.png"
          alt="Mercado Pago"
          style="height:20px;vertical-align:middle;"
        >
      </b-link>
      <b-link
        v-if="mpIosLink != null"
        class="to_MP_button"
        :href="mpIosLink"
      >
        {{ $t('lang.mp_payments.mp_button') }}
        <img
          src="../../assets/img/payments/mp-logo.png"
          alt="Mercado Pago"
          style="height:20px;vertical-align:middle;"
        >
      </b-link>

      <div class="mp_divider">
        <span>{{ $t('lang.mp_payments.or_pay') }}</span>
      </div>
    </div>

    <hr
      v-else
      class="mt-3 mb-3"
    >

    <div
      v-if="isLoading"
      class="text-center mb-3"
    >
      <span>{{ $t('lang.bookings.processing_payment') }}</span>
      <i
        class="icon-spin6 animate-spin ml-2"
        style="font-size: 130%"
      />
    </div>

    <div class="mp_title">
      <h6>{{ $t('lang.mp_payments.form_title') }}</h6>

      <!--    Cards Icons   -->
      <div class="mp_cards">
        <!-- Visa -->
        <div
          role="img"
          data-testid="icon"
          aria-hidden="true"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            fill="none"
            aria-hidden="true"
            viewBox="0 0 25 25"
          ><path
            fill="#1434cb"
            d="m12.408 9.692-1.28 5.987H9.579l1.28-5.987zm6.516 3.866.816-2.249.469 2.249zm1.728 2.12h1.433l-1.25-5.986h-1.323a.705.705 0 0 0-.659.44l-2.323 5.547h1.625l.324-.894h1.986zm-4.042-1.954c.006-1.58-2.185-1.667-2.17-2.373.004-.215.21-.443.657-.502a2.93 2.93 0 0 1 1.527.268l.272-1.269a4.2 4.2 0 0 0-1.449-.265c-1.53 0-2.608.814-2.617 1.979-.01.861.769 1.342 1.356 1.629.603.293.806.481.803.744-.004.401-.481.579-.926.585-.779.013-1.23-.21-1.591-.377l-.28 1.312c.361.166 1.028.31 1.722.318 1.626 0 2.69-.805 2.696-2.049m-6.414-4.032-2.51 5.987H6.049L4.814 10.9c-.075-.294-.14-.402-.368-.526-.372-.202-.987-.391-1.528-.509l.037-.174H5.59c.336 0 .638.223.714.61l.652 3.465 1.612-4.075z"
          /></svg>
        </div>

        <!-- Mastercard -->
        <div
          role="img"
          data-testid="icon"
          aria-hidden="true"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="21"
            fill="none"
            aria-hidden="true"
            viewBox="0 0 21 21"
          ><path
            fill="#f79e1b"
            fill-rule="evenodd"
            d="M20.085 10.657c0 3.307-2.654 5.99-5.927 5.99-3.274 0-5.928-2.682-5.928-5.99s2.654-5.99 5.928-5.99 5.927 2.682 5.927 5.99"
            clip-rule="evenodd"
          /><path
            fill="#eb001b"
            fill-rule="evenodd"
            d="M12.772 10.657c0 3.307-2.653 5.99-5.927 5.99S.918 13.964.918 10.656s2.654-5.99 5.927-5.99c3.274 0 5.927 2.682 5.927 5.99"
            clip-rule="evenodd"
          /><path
            fill="#ff5f00"
            fill-rule="evenodd"
            d="M10.501 5.941a6 6 0 0 0-2.27 4.715c0 1.914.887 3.62 2.27 4.716a6 6 0 0 0 2.27-4.716 6 6 0 0 0-2.27-4.715"
            clip-rule="evenodd"
          /></svg>
        </div>

        <!-- Amex -->
        <div
          role="img"
          data-testid="icon"
          aria-hidden="true"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            fill="none"
            aria-hidden="true"
            viewBox="0 0 25 25"
          ><path
            fill="#016fd0"
            fill-rule="evenodd"
            d="M2.918 7.839A4.92 4.92 0 0 1 7.84 2.917h9.322a4.92 4.92 0 0 1 4.922 4.922v9.322a4.92 4.92 0 0 1-4.922 4.922H7.84a4.92 4.92 0 0 1-4.922-4.922z"
            clip-rule="evenodd"
          /><path
            fill="#fff"
            fill-rule="evenodd"
            d="M9.617 19.135V12.13l12.468.01v1.936l-1.442 1.54 1.442 1.555v1.975h-2.3l-1.224-1.349-1.214 1.355z"
            clip-rule="evenodd"
          /><path
            fill="#016fd0"
            fill-rule="evenodd"
            d="M10.45 18.368V12.9h4.635v1.26H11.95v.854h3.06v1.238h-3.06v.84h3.135v1.275z"
            clip-rule="evenodd"
          /><path
            fill="#016fd0"
            fill-rule="evenodd"
            d="m15.063 18.368 2.565-2.737-2.565-2.73h1.985l1.567 1.733 1.572-1.733h1.9v.044l-2.51 2.686 2.51 2.659v.078h-1.92l-1.594-1.75-1.58 1.75z"
            clip-rule="evenodd"
          /><path
            fill="#fff"
            fill-rule="evenodd"
            d="M10.196 5.912h3.005l1.056 2.397V5.912h3.71l.64 1.797.642-1.797h2.834v7.006H7.108z"
            clip-rule="evenodd"
          /><path
            fill="#016fd0"
            fill-rule="evenodd"
            d="M10.765 6.673 8.34 12.135h1.664l.457-1.094h2.48l.457 1.094h1.705l-2.415-5.462zm.209 3.142.727-1.739.727 1.739z"
            clip-rule="evenodd"
          /><path
            fill="#016fd0"
            fill-rule="evenodd"
            d="M15.082 12.134V6.672l2.338.009 1.204 3.357 1.21-3.366h2.251v5.462l-1.448.013V8.394l-1.367 3.74h-1.322l-1.395-3.751v3.75z"
            clip-rule="evenodd"
          /></svg>
        </div>
      </div>
    </div>

    <div :id="containerId" />

    <!--    Error with MercadoPago style -->
    <div
      v-if="paymentError"
      class="mp_error"
    >
      <svg
        role="img"
        data-testid="sm"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        class="svelte-15zag6n"
        width="13px"
        height="13px"
      ><rect
        width="12"
        height="12"
        rx="6"
        fill="#DC3545"
      /><path
        d="M6.72725 2.90906H5.27271L5.45452 6.90906H6.54543L6.72725 2.90906Z"
        fill="#F5F6F7"
      /><path
        d="M5.99998 7.63633C6.40164 7.63633 6.72725 7.96195 6.72725 8.36361C6.72725 8.76527 6.40164 9.09088 5.99998 9.09088C5.59832 9.09088 5.27271 8.76527 5.27271 8.36361C5.27271 7.96195 5.59832 7.63633 5.99998 7.63633Z"
        fill="#F5F6F7"
      /></svg>
      <p>
        {{ paymentError[Object.keys(paymentError)[0]][0] }}
      </p>
    </div>
  </div>
</template>

<script>
import { API, errorResponse } from '@/api/api';

const mercadopagoSdkUrl = 'https://sdk.mercadopago.com/js/v2';
const PaymentAPI = API.get('payment');

let sdkPromise = null;
let nextContainerId = 0;

function getContainerId() {
  nextContainerId += 1;
  return `cardPaymentBrick_container_${nextContainerId}`;
}

function loadMercadoPagoSdk() {
  if (window.MercadoPago) {
    return Promise.resolve();
  }

  if (sdkPromise) {
    return sdkPromise;
  }

  sdkPromise = new Promise((resolve, reject) => {
    const existingScript = document.querySelector(
      `script[src="${mercadopagoSdkUrl}"]`,
    );

    if (existingScript) {
      existingScript.addEventListener('load', () => {
        resolve();
      });

      existingScript.addEventListener('error', reject);

      return;
    }

    const script = document.createElement('script');

    script.src = mercadopagoSdkUrl;
    script.async = true;

    script.onload = () => {
      resolve();
    };

    script.onerror = (e) => {
      reject(e);
    };

    document.head.appendChild(script);
  });

  return sdkPromise;
}

export default {

  name: 'MPCheckoutApi',

  props: {
    booking: {
      type: Object,
      required: true,
    },
    mpLink: {
      type: String,
      required: false,
    },
    mpIosLink: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      isLoading: true,
      cardPaymentBrickController: null,
      containerId: getContainerId(),
      publicKey: null,
      processingMode: 'automatic',
      paymentError: null,
    };
  },

  computed: {
    amount() {
      return Number(this.booking.total_price || 0);
    },
    mpLocale() {
      switch (this.$i18n.locale) {
        case 'en':
          return 'en-US';
        case 'pt':
          return 'pt-BR';
        default:
          return 'es-AR';
      }
    },
    mpDocType() {
      if (this.booking.user.country !== 'AR') {
        return 'Otro';
      }
      if (this.booking.user.doc_type === 'dni_arg' || this.booking.user.doc_type === null) {
        return 'DNI';
      }
      return 'Otro';
    },
    userIsArg() {
      if (this.booking.user.country === 'AR') {
        return true;
      }
      return false;
    },
  },

  async mounted() {
    try {
      this.publicKey = this.booking.store.payment_provider_public_key;
      if (!this.publicKey) {
        throw new Error('publicKey missing');
      }

      if (!this.amount) {
        throw new Error('amount missing');
      }

      await loadMercadoPagoSdk();

      const mp = new window.MercadoPago(
        this.publicKey,
        {
          locale: this.mpLocale,
        },
      );

      const bricksBuilder = mp.bricks();

      await this.renderCardPaymentBrick(bricksBuilder);
    } catch (error) {
      this.handleError(error);
    }
  },

  beforeDestroy() {
    if (this.cardPaymentBrickController) {
      this.cardPaymentBrickController.unmount();
    }
  },

  methods: {
    async renderCardPaymentBrick(bricksBuilder) {
      const settings = {

        initialization: {
          amount: this.amount,
          payer: {
            email: this.booking.user.email,
            identification: {
              type: this.mpDocType,
              number: this.booking.user.doc_number,
            },
          },
        },
        customization: {
          visual: {
            hideFormTitle: true,
            style: {
              theme: 'bootstrap', // bootstrap | dark | flat
              customVariables: {
                baseColor: '#ff1460',
                fontSizeExtraLarge: '14px',
                formPadding: '5px',
              },
            },
            texts: {
              formSubmit: this.$t('lang.bookings.payment'),
              cardholderName: {
                label: this.$t('lang.mp_payments.card_holder_name'),
              },
              securityCode: {
                label: 'CVV',
              },
            },
          },
          paymentMethods: {
            maxInstallments: 1,
          },
        },
        callbacks: {
          onReady: () => {
            this.isLoading = false;
          },
          onSubmit: this.submitOrder,

          onError: (error) => {
            this.handleError(error);
          },
        },
      };
      this.cardPaymentBrickController = await bricksBuilder.create(
        'cardPayment',
        this.containerId,
        settings,
      );
    },

    async submitOrder(formData, additionalData) {
      this.paymentError = null;
      try {
        const payload = {
          booking_id: this.booking.id,
          payment_provider: 'mp',
          payment_data: {
            payment_method: {
              id: formData.payment_method_id,
              type: additionalData.paymentTypeId,
              token: formData.token,
              installments: formData.installments,
            },
            payer: {
              identification: {
                type: formData.payer.identification.type,
                number: formData.payer.identification.number,
              },
            },
          },
        };
        const { data } = await PaymentAPI.createMpApiPayment(payload);

        if (data.payment_status === 'approved' && data.payment_status_detail === 'accredited') {
          const url = `/process_payment/mp?external_reference=${this.booking.id}&payment_id=${data.payment_code}`;
          await this.$router.push(url);
        } else {
          if (this.$te(`lang.mp_payments.errors.${data.payment_status_detail}`)) {
            this.paymentError = { error: [this.$t(`lang.mp_payments.errors.${data.payment_status_detail}`)] };
          } else {
            this.paymentError = { error: [this.$t('lang.mp_payments.payment_error')] };
          }
          throw new Error('Payment failed');
        }
      } catch (error) {
        if (this.paymentError === null) {
          this.paymentError = errorResponse(error);
        }
        throw error;// para que el Brick sepa que falló
      }
    },

    handleError(error) {
      this.isLoading = false;
      this.$emit(
        'paymentError',
        error,
      );
    },
  },

};
</script>

<style scoped>
</style>
